function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36.8334 22.5985V6.50016C36.8334 5.3085 35.8584 4.3335 34.6667 4.3335H17.3334C16.1417 4.3335 15.1667 5.3085 15.1667 6.50016V22.5985C15.1667 23.3568 15.5567 24.0718 16.2284 24.4618L25.2851 29.9002L23.1401 34.9702L18.3301 35.3818C17.3334 35.4685 16.9434 36.6602 17.6801 37.2885L21.3417 40.4518L20.2367 45.1752C20.0201 46.1068 21.0384 46.8435 21.8617 46.3452L26.0001 43.8318L30.1384 46.3235C30.9617 46.8218 31.9801 46.0852 31.7634 45.1535L30.6584 40.4302L34.3201 37.2668C35.0351 36.6385 34.6667 35.4468 33.6917 35.3602L28.8817 34.9485L26.7367 29.8785L35.7934 24.4402C36.4434 24.0718 36.8334 23.3785 36.8334 22.5985ZM28.1667 26.4985L26.0001 27.7985L23.8334 26.4985V6.50016H28.1667V26.4985Z",
  fill: "#043E7D"
});

function SvgWoozeeeMedal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoozeeeMedal);
export default __webpack_public_path__ + "static/media/woozeeeMedal.872738b0.svg";
export { ForwardRef as ReactComponent };